import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { History as HistoryIcon } from '@mui/icons-material';
import { formatDistanceToNow } from 'date-fns';
import { DEFAULT_SEARCH_FILTERS } from '../../store/searchSlice';

// Friendly labels for whichever filters were actually set, so a recent
// search reads as e.g. "Customer: Smith, Part #: V10-7423" rather than
// dumping the whole filters object at the user.
const FILTER_LABELS = {
  customerNameCash: 'Customer',
  customerNameAccount: 'Account',
  registration: 'Reg',
  partNumber: 'Part #',
  itemDescription: 'Item',
  cashSaleNumber: 'Cash Sale #',
  refundNumber: 'Refund #',
  invoiceNumber: 'Invoice #',
  creditNoteNumber: 'Credit Note #',
  orderNumber: 'Order #',
  startDate: 'From',
  endDate: 'To'
};

const summarizeFilters = (filters) => {
  const parts = Object.keys(FILTER_LABELS)
    .filter((key) => filters[key] && filters[key] !== DEFAULT_SEARCH_FILTERS[key])
    .map((key) => `${FILTER_LABELS[key]}: ${filters[key]}`);
  return parts.length > 0 ? parts.join(', ') : 'All transactions';
};

const RecentSearches = ({ searches, onSelect }) => {
  if (!searches || searches.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
        <HistoryIcon fontSize="small" color="action" />
        <Typography variant="subtitle2" color="text.secondary">
          Recent Searches
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {searches.map((entry) => (
          <Chip
            key={entry.id}
            label={`${summarizeFilters(entry.filters)} (${entry.resultCount} result${entry.resultCount === 1 ? '' : 's'}, ${formatDistanceToNow(new Date(entry.timestamp), { addSuffix: true })})`}
            onClick={() => onSelect(entry.filters)}
            variant="outlined"
            size="small"
          />
        ))}
      </Box>
    </Box>
  );
};

export default RecentSearches;
